import type { StaticLayerPayload } from "@config";
import { SeparatorLibrary } from "@library-elements/separator";
import type { ComponentType } from "react";
import { Container } from "../Container";

const Views: Record<string, ComponentType<StaticLayerPayload>> = {
  default: SeparatorLibrary,
};

export const Separator = ({ entity }: StaticLayerPayload) => (
  <Container entity={entity} views={Views} />
);
